module.exports = __webpack_public_path__ + "img/icon_my_curve_list.43b2503e.svg";